import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Paper.module.css';

export type PaperProps = HTMLAttributes<HTMLDivElement> & {
  withBorder?: boolean;
  p?: 'none' | 'xs' | 'sm' | 'md' | 'lg';
  radius?: 'md' | 'sm' | 'comfortable';
  shadow?: 'none' | 'sm' | 'md';
  children: ReactNode;
};

const padMap = {
  none: '0',
  xs: 'var(--wp-space-8)',
  sm: 'var(--wp-space-12)',
  md: 'var(--wp-space-16)',
  lg: 'var(--wp-space-24)',
};

export function Paper({
  withBorder = false,
  p = 'md',
  radius = 'md',
  shadow = 'none',
  className,
  style,
  children,
  ...rest
}: PaperProps) {
  return (
    <div
      className={cx(styles.paper, withBorder && styles.bordered, styles[`r_${radius}`], styles[`sh_${shadow}`], className)}
      style={{ padding: padMap[p], ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}
